import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import BlurredInfos from './components/BlurredInfos';
import FullInfos from './components/FullInfos';
import Modal from '../../components/lib/Modal';
import GlassCard from '../../components/lib/GlassCard';

import { updateModalPropertyId } from '../../../../../../reducers/_Pages/Public/radarSlice';
import PROPERTIES from '../../../../../../api/ressources/SellerApp/properties';

const PropertyModal = () => {
  const { user } = useSelector((state) => state.user);
  const { modalPropertyId, loginModalOpen, phoneNumberModalOpen } = useSelector((state) => state.radar);
  const [property, setProperty] = useState({})
  const [searchParams, _] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (modalPropertyId || !searchParams.get('pid')) return;

    dispatch(updateModalPropertyId(parseFloat(searchParams.get('pid'))))
  }, []);

  useEffect(() => {
    if (!modalPropertyId) return;

    const fetchProperty = async () => {
      setProperty({})
      
      try {
        const response = await PROPERTIES.getRadarProperty(modalPropertyId)
        
        setProperty(response.data);
      } catch (_) {
        dispatch(updateModalPropertyId(null))
      }
    }

    fetchProperty();

    return () => {
      if (modalPropertyId) return;
      
      setTimeout(() => setProperty({}), 300);
    }  
  }, [modalPropertyId, user.id]);

  return (
    <Modal isOpen={modalPropertyId != null && !loginModalOpen && !phoneNumberModalOpen} closeModal={() => dispatch(updateModalPropertyId(null))}>
      {property.id != null &&
        <GlassCard hoverBgColor='' width='w-full xl:w-[800px]' paddings='p-0 pb-6 md:pb-0'>
          {user.id ? <FullInfos property={property} setProperty={setProperty} /> : <BlurredInfos property={property} />}
        </GlassCard>
      }
    </Modal>
  )
}

export default PropertyModal;
